// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadbill-container {
  background: #f8f8f8;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 95%;
  margin: 3% auto;
  text-align: left;
}

.back-bill {
  height: 20px;
  margin-bottom: 3%;
  display: flex;
  align-items: baseline;
  cursor: pointer;
  font-size: 14px;
  width: 7%;
}

.back-bill i {
  margin-right: 10px;
}

.cont-uploadbills {
  display: flex;
  justify-content: space-between;
}

.cont-uploadbills button {
  background-color: transparent;
  color: #7aa6bd;
  text-decoration: underline;
}

.infoaccount {
  border: 1px solid #ccc;
  margin-bottom: 8px;
}

.input-with-icon {
  position: relative;
}

.input-with-icon input {
  padding-right: 30px; /* Ajusta el espaciado derecho según sea necesario */
}

.input-with-icon .icon {
  cursor: pointer;
  color: rgb(65, 186, 65);
  font-size: 20px;
  position: absolute;
  top: 50%;
  right: 10px; /* Ajusta la posición del ícono según sea necesario */
  transform: translateY(-50%);
}

.form-itemText {
  display: flex;
}

.form-itemText label {
  display: block;
  font-weight: bold;
  margin-bottom: 8px;
  margin-right: 2%;
}

.form-itemText i {
  cursor: pointer;
  color: #5a5766;
}

.cont-dates {
  display: flex;
}

.dateform {
  margin-right: 5%;
}

.form-group select {
  border: 1px solid black;
  border-radius: 0;
}

.uploadbill-container .form-group input {
  border: 1px solid black;
  border-radius: 0;
}

.uploadbill-container .form-group input.billExists {
  border: 2px solid red;
}

.error-message {
  color: red;
  font-weight: 600;
}

.error-billId{
  display: block;
  color: red;
  font-weight: 600;
  /* width: 100%; */
}

.disabled-create{
  background-color: rgb(168, 168, 168);
  cursor: not-allowed;
}
.disabled-create:hover{
  background-color: rgb(168, 168, 168);
}

.is-invalid {
  border: 2px solid red;
}


.custom-file-input {
  position: relative;
  overflow: hidden;
  width: 150px;
  cursor: pointer;
  color: transparent;
  margin-right: 0;
}

.custom-file-input::before {
  content: 'Selecciona archivo';
  display: inline-block;
  padding: 5px 10px;
  color: white;
  background-color: #bfbfbf;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
}

.custom-file-input:hover::before {
  background-color: #898989;
}

.custom-file-input::-webkit-file-upload-button {
  visibility: hidden;
}

.btn-pdf{
  display: inline-block;
  padding: 10px 10px;
  color: white;
  background-color: #7aa6bd;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  border-radius: 0%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/UploadBill/UploadBill.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,EAAE,oDAAoD;AAC3E;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,qDAAqD;EAClE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".uploadbill-container {\n  background: #f8f8f8;\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  max-width: 95%;\n  margin: 3% auto;\n  text-align: left;\n}\n\n.back-bill {\n  height: 20px;\n  margin-bottom: 3%;\n  display: flex;\n  align-items: baseline;\n  cursor: pointer;\n  font-size: 14px;\n  width: 7%;\n}\n\n.back-bill i {\n  margin-right: 10px;\n}\n\n.cont-uploadbills {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cont-uploadbills button {\n  background-color: transparent;\n  color: #7aa6bd;\n  text-decoration: underline;\n}\n\n.infoaccount {\n  border: 1px solid #ccc;\n  margin-bottom: 8px;\n}\n\n.input-with-icon {\n  position: relative;\n}\n\n.input-with-icon input {\n  padding-right: 30px; /* Ajusta el espaciado derecho según sea necesario */\n}\n\n.input-with-icon .icon {\n  cursor: pointer;\n  color: rgb(65, 186, 65);\n  font-size: 20px;\n  position: absolute;\n  top: 50%;\n  right: 10px; /* Ajusta la posición del ícono según sea necesario */\n  transform: translateY(-50%);\n}\n\n.form-itemText {\n  display: flex;\n}\n\n.form-itemText label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 8px;\n  margin-right: 2%;\n}\n\n.form-itemText i {\n  cursor: pointer;\n  color: #5a5766;\n}\n\n.cont-dates {\n  display: flex;\n}\n\n.dateform {\n  margin-right: 5%;\n}\n\n.form-group select {\n  border: 1px solid black;\n  border-radius: 0;\n}\n\n.uploadbill-container .form-group input {\n  border: 1px solid black;\n  border-radius: 0;\n}\n\n.uploadbill-container .form-group input.billExists {\n  border: 2px solid red;\n}\n\n.error-message {\n  color: red;\n  font-weight: 600;\n}\n\n.error-billId{\n  display: block;\n  color: red;\n  font-weight: 600;\n  /* width: 100%; */\n}\n\n.disabled-create{\n  background-color: rgb(168, 168, 168);\n  cursor: not-allowed;\n}\n.disabled-create:hover{\n  background-color: rgb(168, 168, 168);\n}\n\n.is-invalid {\n  border: 2px solid red;\n}\n\n\n.custom-file-input {\n  position: relative;\n  overflow: hidden;\n  width: 150px;\n  cursor: pointer;\n  color: transparent;\n  margin-right: 0;\n}\n\n.custom-file-input::before {\n  content: 'Selecciona archivo';\n  display: inline-block;\n  padding: 5px 10px;\n  color: white;\n  background-color: #bfbfbf;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center;\n}\n\n.custom-file-input:hover::before {\n  background-color: #898989;\n}\n\n.custom-file-input::-webkit-file-upload-button {\n  visibility: hidden;\n}\n\n.btn-pdf{\n  display: inline-block;\n  padding: 10px 10px;\n  color: white;\n  background-color: #7aa6bd;\n  cursor: pointer;\n  font-size: 14px;\n  text-align: center;\n  border-radius: 0%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
